import styled from 'styled-components';

export const ListContainer = styled.ul`
  padding: 0 15px 0 15px;
  margin-top: 24px;

  @media ${({ theme }) => theme.device.desktop} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 20px;
    padding: 0;
    width: 966px;
  }
  &.has-filters {
    margin-top: 8px;
  }
`;
